<template>
  <v-container class="forget-wrapper">
    <v-card
      class="mx-auto forget-card"
      max-width="500"
    >
      <v-window v-model="step">
        <v-card-title class="title font-weight-regular justify-space-between">
          <span>{{ currentTitle }}</span>
            <v-avatar
            color="green"
            class="subheading white--text"
            size="24"
            v-text="step"
          ></v-avatar>
        </v-card-title>

        <v-window-item :value="1">
          <v-card-text>
            <v-text-field
              label="Email"
              v-model="forget_name"
            ></v-text-field>
            <span v-if="!errnotif" class="caption grey--text text--darken-1">
              This is the email you use to login to your Corporate Dashboard account
            </span>
            <span v-else class="caption red--text text--darken-1">
              {{errnotif}}
            </span>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              class="grey--text"
              flat
              @click="$emit('forgetEmit', null)"
            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="green"
              class="white--text"
              depressed
              v-if="loading"
            >
              <div class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
              </div>
            </v-btn>
            <v-btn
              color="green"
              class="white--text"
              depressed
              v-else
              @click="sendForgetPass"
            >
              Next
            </v-btn>
          </v-card-actions>
        </v-window-item>

        <v-window-item :value="2">
          <v-card-text>
            <v-text-field
              v-model="change.username"
              label="Email"
            ></v-text-field>
            <v-text-field
              v-model="change.verification_code"
              label="Verification Code"
            ></v-text-field>
            <v-text-field
              v-model="change.password"
              label="Password"
              type="password"
            ></v-text-field>
            <v-text-field
              v-model="change.confirm_password"
              label="Confirm Password"
              type="password"
            ></v-text-field>
            <span v-if="!errnotif" class="caption grey--text text--darken-1">
              Check your email to get verification code
            </span>
            <span v-else class="caption red--text text--darken-1">
              {{errnotif}}
            </span>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              class="grey--text"
              flat
              @click="step--"
            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="green"
              class="white--text"
              depressed
              v-if="loading"
            >
              <div class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
              </div>
            </v-btn>
            <v-btn
              color="green"
              class="white--text"
              depressed
              v-else
              @click="changePass"
            >
              Change
            </v-btn>
          </v-card-actions>
        </v-window-item>
      </v-window>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/helpers/axios'

export default {
  data: () => ({
    step: 1,
    loading: false,
    forget_name: '',
    errnotif: '',
    change: {
      username: '',
      verification_code: '',
      password: '',
      confirm_password: ''
    }
  }),
  methods: {
    sendForgetPass () {
      this.loading = true
      let dataBody = {
        username: this.forget_name
      }

      let reqBody = Object.keys(dataBody).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(dataBody[key])
      }).join('&')

      axios.post('/forget', reqBody)
        .then(response => {
          this.loading = false
          if (this.step === 1) {
            this.step++
          }
          this.errnotif = ''
        })
        .catch(error => {
          this.loading = false
          this.errnotif = error.response.data.message
        })
    },
    changePass () {
      let reqBody = this.change

      axios.post('/change_password', reqBody)
        .then(response => {
          this.loading = false
          this.$emit('forgetEmit', true)
        })
        .catch(error => {
          this.loading = false
          this.errnotif = error.response.data.message
        })
    }
  },
  computed: {
    currentTitle () {
      switch (this.step) {
        case 1: return 'Forget Password'
        case 2: return 'Change Password'
        default: return ''
      }
    }
  }
}
</script>

<style scoped>
.forget-wrapper {
  position: fixed!important;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: whitesmoke;
  width: 100vw!important;
  max-width: 100vw!important;
  height: 100vh!important;
}

.forget-card {
  /* margin-top: 20vh; */
}

.primary--text, .green--text {
  color: rgb(77, 189, 153)!important;
}

.green {
  background: rgb(77, 189, 153)!important;
}
</style>
